function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 加入购物车
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      var beforScrollTop = $(document).scrollTop()
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 走马灯
    var stringEl = $('.str3').liMarquee({
      scrollamount: 100,
      loop: -1,
    })
    // 轮播图
    var swiper = new Swiper('.mySwiper', {
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var swiper2 = new Swiper('.mySwiper2', {
      slidesPerView: 2,
      spaceBetween: 0,
      navigation: {
        nextEl: '.sp-swiper-boxs .swiper-button-next',
        prevEl: '.sp-swiper-boxs .swiper-button-prev',
      },
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })

    var swiper3 = new Swiper('.mySwiper3', {
      slidesPerView: 1.3,
      spaceBetween: 39,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      loop: true,
      autoplay: {
        delay: 2000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-purple-big.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-pink-big.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-blue-big.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-black-big.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-grey-big.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-purple-big2.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-pink-big2.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-blue-big2.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-black-big2.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-grey-big2.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-purple-big4.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-pink-big4.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-blue-big4.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-black-big4.png',
      'https://cdn.shopify.com/s/files/1/0661/6147/5823/files/20240813-grey-big4.png',
    ]
    var swiper4 = new Swiper('.mySwiper4', {
      observer: true,
      observeParents: true,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      spaceBetween: 20,
      navigation: {
        nextEl: '.sp-swiper-small .swiper-button-next',
        prevEl: '.sp-swiper-small .swiper-button-prev',
      },
      on: {
        slideChange: function () {
          choseActive(this.activeIndex)
        },
      },
    })
    var swiper5 = new Swiper('.mySwiper5', {
      thumbs: {
        swiper: swiper4,
      },
    })
    swiper4.el.onclick = function (e) {
      // var target = e.target
      // $('.mySwiper4 .swiper-slide').removeClass('swiper-slide-tapactive')
      // // 检查点击的是否为图片
      // if (target.tagName.toUpperCase() === 'IMG') {
      //   target.parentNode.classList.add('swiper-slide-tapactive') // 添加类名
      // }
      // 切换到点击的slide
      var clickIndex = e.target.parentNode.getAttribute('data-index')
      swiper5.slideTo(clickIndex)
      $('.sp-pro-img>img').attr('src', imgArr[clickIndex])
      //
      choseActive(clickIndex)
    }
    // 初始化
    alignmentFns.initialize()
    // 数量
    let prods = window.product
    function getCur(){
      let color = $('.sp-chose-wraper li.active').attr('data-val')
      let size = $('.sp-size-wraper li.active').attr('data-val')
      return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
    }
    function changePrice(){
      let num = $('#2').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      // if(num == 1){
      //   price = (getCur().price * num / 100).toFixed(2)
      // }else if(num == 2){
      //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
      // }else if(num == 3){
      //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
      // }else {
      //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
      // }
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".sp-part5 .off_number").html(off_font);
    }
    $('.sp-buynow').click(function(){
      let num = $('#2').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    $('#addCart').click(function () {
      // do something here
      var data = {
        id: getCur().id,
        quantity: $('#2').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".buy-car span").html(result.item_count);
          });
        },
        dataType: "json",
      });
      
      var img = $('.sp-pro-img img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.sp-part5').append(flyer)
      $('.clone').css({
        width: '924px',
        height: '802px',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.buy-car')[0].getBoundingClientRect()
      $('.buy-car').addClass('shake')
      setTimeout(() => {
        $('.buy-car').removeClass('shake')
      }, 1000)
      let finish = $('.buy-car')
      $('.clone').animate(
        {
          top: finish[0].offsetTop,
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
    $('#2').change(function () {
      changePrice()
    })
    $('.sp-chose-wraper li').click(function () {
      var index = $(this).index()
      $(this).addClass('active').siblings().removeClass('active')
      var index2 = $('.sp-size-wraper li.active').index()
      $('.sp-pro-img>img').attr('src', imgArr[index + index2 * 5])
      swiper5.slideTo(index + index2 * 5)
      changePrice()
    })
    $('.sp-size-wraper li').click(function () {
      var index = $(this).index()
      var index2 = $('.sp-chose-wraper li.active').index()
      $(this).addClass('active').siblings().removeClass('active')
    //   $('.sp-pro-img>img').attr('src', imgArr[index2 + index * 5])
    //   swiper5.slideTo(index2 + index * 5)
      changePrice()
    })
    function choseActive(clickIndex) {
      var index = 0
      var index2 = 0
      var currentIndex = (clickIndex * 5) / 5
      if (currentIndex < 5) {
        index = (clickIndex * 5) / 5
        index2 = 0
      } else if (currentIndex < 10) {
        index = (clickIndex * 5) / 5 - 5
        index2 = 1
      } else {
        index = (clickIndex * 5) / 5 - 10
        index2 = 2
      }
      $('.sp-chose-wraper li')
        .eq(index)
        .addClass('active')
        .siblings()
        .removeClass('active')
      $('.sp-size-wraper li')
        .eq(index2)
        .addClass('active')
        .siblings()
        .removeClass('active')
    }
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
